import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useSortContext } from '../../context/SortContext';
import SortOptionsPanel from '../SortOptionsPanel';
import styles from './MobileSortButton.module.css';

const MobileSortButton = () => {
  const { hasCustomSortSettings } = useSortContext();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={`${styles.sortButton} ${hasCustomSortSettings ? styles.active : ''}`}
        onClick={() => setIsOpen(true)}
        aria-label="Sort"
      >
        <span className={styles.sortText}>Sort</span>
        {hasCustomSortSettings && <span className={styles.sortBadge}></span>}
      </button>

      {isOpen && createPortal(
        <>
          <button
            type="button"
            className={styles.modalBackdrop}
            onClick={() => setIsOpen(false)}
            aria-label="Close sort options"
          />
          <div className={styles.modalOverlay}>
            <dialog className={styles.modalContent} open>
              <div className={styles.modalHeader}>
                <h2>Sort</h2>
                <button
                  type="button"
                  className={styles.closeButton}
                  onClick={() => setIsOpen(false)}
                >
                  ×
                </button>
              </div>
              <div className={styles.modalBody}>
                <SortOptionsPanel showLeagueLocks={false} />
              </div>
            </dialog>
          </div>
        </>,
        document.body
      )}
    </>
  );
};

export default MobileSortButton;
